import React from 'react'

const ActivityGroupView = () => {
  return (
    <div>ActivityGroupView</div>
  )
}

export default ActivityGroupView